
// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import {getAuth} from "firebase/auth"

// Your web app's Firebase configuration
const firebaseConfig = {
   apiKey: "AIzaSyAh_oyPuFobEUJilpmhVRf-zqf7RJqo_lM",
   authDomain: "bullscreen-d6ea4.firebaseapp.com",
   projectId: "bullscreen-d6ea4",
   storageBucket: "bullscreen-d6ea4.firebasestorage.app",
   messagingSenderId: "955507334955",
   appId: "1:955507334955:web:3c883513f0ae3f0b67ef6e"
 };
 

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
let auth = firebase.auth();

 const authentication = getAuth(app)
export {firebase , authentication, auth};
